import React from 'react';
import css from './BuilderPage.module.css';
import { BuilderComponent } from '../../components/builderSection/BuilderComponent/BuilderComponent';

const BuilderPage = () => {
    return (
        <section className={css.wrap}>
            <BuilderComponent />
        </section>
    );
};

export { BuilderPage };
